// The guided setup wizard's stages, derived from the quote's nav sections.
//
// Stage 1 is always the quantity. Then, PER priceable nav SECTION (e.g. Carton), a 'line' stage and a
// 'solution' stage -- one manufacturing line and one solution are chosen per section, never per sub_section.
// The nav builder's 'general' catch-all is not a manufacturing part section, so it is skipped. sectionIndex is
// the section's OWN position in navSections (the value every /mcc endpoint and the URL state key off), so the
// wizard, the address bar and the server all address the same section.
//
// So the total number of stages is `1 + 2 * (number of priceable sections)`: a one-section Carton is 3 stages,
// a two-section drawing is 5 ("Stage 3 of 5").
export const buildSetupWizardStages = (navSections) => {
  const priceableSections = (navSections || [])
    .map((section, index) => ({ section, index }))
    .filter(({ section }) => section.part_type !== 'general');

  return [
    { type: 'quantity' },
    ...priceableSections.flatMap(({ section, index }) => [
      { type: 'line', sectionIndex: index, label: section.label || section.part_type },
      { type: 'solution', sectionIndex: index, label: section.label || section.part_type },
    ]),
  ];
};

export default buildSetupWizardStages;
